import { render, staticRenderFns } from "./SalesPerProvince.vue?vue&type=template&id=0d79c072"
import script from "./SalesPerProvince.vue?vue&type=script&lang=js"
export * from "./SalesPerProvince.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports